import { AnalyticsEvent } from '../models';

export class IngredientsPageLoadEvent implements AnalyticsEvent {
  name = 'IngredientsPageLoadEvent';

  constructor() {}
}